var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"plan-info-modal"},[_c('div',{staticClass:"plan-info-modal__icon"}),_c('div',{staticClass:"plan-info-modal__text"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),(_vm.buttonText)?_c('div',{staticClass:"button-v3",on:{"click":_vm.onButtonClick}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }